import * as routes from './routes';

/**
 * Uses named exports of route names to aggregate all into one constant (ROUTE_NAMES).
 * Maintaing named exports also allows for verifying against duplicate keys and values
 * to avoid accidental collisions.
 * @see routeNames.spec.ts
 */
function getRouteNames(): Record<string, string> {
  return Object.keys(routes).reduce((acc, routeGroup) => {
    return Object.assign(acc, routes[routeGroup]);
  }, {});
}

export const ROUTE_NAMES = getRouteNames();
